import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/views/layout/layout'
// import orderRouter from './order'

const orderManageRouter = { // 订单管理
  path: '/agentOrderManage',
  component: Layout,
  redirect: 'orderManage',
  meta: {
    title: '订单管理',
    icon: 'order',
    roles: ['agent']
  },
  children: [
    {
      path: 'TransactionOrder',
      component: resolve => require(['@/views/agent/orderManage/TransactionOrder'], resolve),
      name: 'TransactionOrder',
      meta: { title: '商户网银充值订单', noCache: false }
    },
    {
      path: 'TransactionOrderU',
      component: resolve => require(['@/views/agent/orderManage/TransactionOrderU'], resolve),
      name: 'TransactionOrderU',
      meta: { title: 'USDT充值订单', noCache: false }
    },
    {
      path: 'TransactionUSDTOrder',
      component: resolve => require(['@/views/agent/orderManage/TransactionUSDTOrder'], resolve),
      name: 'TransactionUSDTOrder',
      meta: { title: 'USDT代收订单', noCache: false }
    },
    // {
    //   path: 'TransactionCFBOrder',
    //   component: resolve => require(['@/views/agent/orderManage/TransactionCFBOrder'], resolve),
    //   name: 'TransactionCFBOrder',
    //   meta: { title: 'CFB代收订单', noCache: false }
    // },
    {
      path: 'PaidOrder',
      component: resolve => require(['@/views/agent/orderManage/PaidOrder'], resolve),
      name: 'PaidOrder',
      meta: { title: '商户提现订单', noCache: false }
    },
    {
      path: 'dealerPaidOrder',
      component: resolve => require(['@/views/agent/orderManage/dealerPaidOrder'], resolve),
      name: 'DealerPaidOrder',
      meta: { title: '代理提现订单', noCache: false }
    }
  ]
}

export default orderManageRouter



// WEBPACK FOOTER //
// ./src/router/agent/orderManage.js